<template>
    <approval></approval>
</template>

<script>
import approval from '@/components/3pl/Settings/Approval/Home/index.vue'
export default {
components:{
    approval
}
}
</script>

<style>

</style>